import { render } from "./DomainView.vue?vue&type=template&id=ebcf30fe&scoped=true"
import script from "./DomainView.vue?vue&type=script&lang=js"
export * from "./DomainView.vue?vue&type=script&lang=js"

import "./DomainView.vue?vue&type=style&index=0&id=ebcf30fe&scoped=true&lang=less"

import exportComponent from "/build/cloudstack/dist/rpmbuild/BUILD/cloudstack-4.18.1.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebcf30fe"]])

export default __exports__